import React, { Suspense, lazy, useState, useEffect } from 'react';
import { HelmetProvider, Helmet } from 'react-helmet-async';
import { Route, Switch, useLocation, Redirect } from 'react-router-dom';
import { AuthProvider } from '../../context/auth';
import classnames from 'classnames';
import { useMediaQuery } from 'react-responsive';
import ReactNotification from 'react-notifications-component';
import 'react-notifications-component/dist/theme.css';
import { isMobile } from 'react-device-detect';
import isEmpty from '../../validation/is-empty';

import './App.scss';
import Navbar from './navbar/Navbar';

// Helpers
import AuthRoute from '../../util/AuthRoute';
import PrivateRoute from '../../util/PrivateRoute';
import Fa from "react-timeago/lib/language-strings/fa";

// Public Routes
const Register = lazy(() => import('./auth/register/Register'));
const VerifyEmail = lazy(() => import('./auth/verify-email/VerifyEmail'));
const Login = lazy(() => import('./auth/login/Login'));
const ForgotPassword = lazy(() =>
  import('./auth/forgot-password/ForgotPassword')
);
const RestorePassword = lazy(() =>
  import('./auth/restore-password/RestorePassword')
);
// const Spdm = lazy(() => import('./spdm/facturacion/Facturacion'));
const InvoicePortal = lazy(() => import('./invoice-portal/InvoicePortal'));
const NotFound = lazy(() => import('../not-found/NotFound'));
// Private Routes
const Dashboard = lazy(() => import('./dashboard/Dashboard'));
const Invoices = lazy(() => import('./invoices/Invoices'));
const Invoicing = lazy(() => import('./invoicing/Invoicing'));
const Facturacion = lazy(() => import('./spdm/facturacion/Facturacion'));
const IHaveSpace = lazy(() => import('./i-have-space/IHaveSpace'));
const Collection = lazy(() => import('./collection/Collection'));
const Profile = lazy(() => import('./profile/Profile'));
const MyOrganizations = lazy(() =>
  import('./my-organizations/MyOrganizations')
);
const Settings = lazy(() => import('./settings/Settings'));

function Facti() {
  const [showNavbar, setShowNavbar] = useState(true);
  const { pathname } = useLocation();
  const withNavbar =
    showNavbar &&
    !isEmpty(localStorage.getItem('jwtToken')) &&
    pathname !== '/spdm/facturacion';
  const sideNavFixed = useMediaQuery({
    query: '(min-width: 1280px)',
  });
  const [inProduction] = useState(
    process.env.REACT_APP_ENV === 'production' ? true : false
  );

  useEffect(() => {
    return () => {
      document.getElementById('manifest-app').remove();
    };
  }, []);

  return (
    <div
      className={classnames('App', {
        'with-navbar': withNavbar,
        'sidenav-fixed': withNavbar && sideNavFixed,
      })}
    >
      <HelmetProvider>
        <Helmet>
          <link id="manifest-app" rel="manifest" href="/manifest-app.json" />
          {isMobile && <body class="mobile" />}
        </Helmet>
        <ReactNotification />
        <main className="content-wrap">
          <AuthProvider>
            <Navbar showNavbar={showNavbar} sideNavFixed={sideNavFixed} />
            <Suspense fallback={null}>
              <Switch>
                <Route exact path="/facturacion" component={Invoicing} />
                <Route path="/login" exact render={() => <Redirect to="/" />} />
                <AuthRoute exact path="/" component={Login} />
                {!inProduction && (
                  <AuthRoute exact path="/register" component={Register} />
                )}
                <Route
                  exact
                  path="/verify-email/:token/"
                  component={VerifyEmail}
                />
                {!inProduction && (
                  <AuthRoute
                    exact
                    path="/forgot-password"
                    component={ForgotPassword}
                  />
                )}
                <AuthRoute
                  exact
                  path="/restore-password/:token/"
                  component={RestorePassword}
                />
                <PrivateRoute exact path="/dashboard" component={Dashboard} />
                <PrivateRoute exact path="/my-invoices" component={Invoices} />
                <PrivateRoute exact path="/invoicing" component={Invoicing} />
                <PrivateRoute
                  exact
                  path="/i-have-space"
                  component={IHaveSpace}
                />
                <PrivateRoute exact path="/collection" component={Collection} />
                <PrivateRoute exact path="/profile" component={Profile} />
                <PrivateRoute
                  exact
                  path="/my-organizations"
                  component={MyOrganizations}
                />
                <PrivateRoute exact path="/settings" component={Settings} />
                <Route
                  exact
                  path="/:alias/facturacion/"
                  component={Facturacion}
                />
                <Route
                  component={() => <NotFound setShowNavbar={setShowNavbar} />}
                />
              </Switch>
            </Suspense>
          </AuthProvider>
        </main>
      </HelmetProvider>
    </div>
  );
}

export default Facti;
